import { PropsWithChildren } from "react";

import styles from "./ReviewedDateContainer.module.scss";

/**
 * Container for date reviewed care elements. Contains grid layout and styling.
 * @component
 * @example
 * <ReviewedCareElementContainer>
 *   <DateReviewedElement />
 * </ReviewedCareElementContainer>
 * @param props Contains children elements to be rendered inside the container.
 * @property {React.ReactNode} props.children - The child elements to be rendered inside the container.
 * @returns JSX.Element
 */
export function ReviewedCareElementContainer(props: PropsWithChildren<unknown>): JSX.Element {
    return (
        <div className={styles.container}>
            {props.children}
        </div>
    );
}
